import React, { useState, useEffect } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { faAngleLeft, faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Api
import usuario_api from '../../../../../api/usuario_api';
import colegiadoVotacao_api from '../../../../../api/colegiadoVotacao_api';

//Context
import { useAuth } from '../../../../../context/auth';

//Helpers
import { showMessage } from '../../../../../helpers/message';
import { getSessionCookie } from '../../../../../helpers/cookies';
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';

//Components
import MainCard from '../../../../../components/MainCard';
import TextField from '../../../../../components/TextField';

function initialStateColegiadoVotacao(secretaria_Id) {
    return {
        identificacao: "",
        status: "Ativo",
        secretaria_Id: secretaria_Id,
        colegiadoUsuarios: []
    }
}
function CadastroColegiadoVotacao({ id, handleVoltar, editavel }) {
    // Objeto
    const session = getSessionCookie();

    //State para criar/editar
    const [colegiadoVotacao, setColegiadoVotacao] = useState(initialStateColegiadoVotacao(session.secretaria_Id));

    //State para lista de usuários
    const [listUsuarios, setListUsuarios] = useState([]);

    //State para pegar erros
    const [errors, setErrors] = useState({});

    const { setLoading } = useAuth();

    const loadUsuarios = () => {
        setLoading(true);
        usuario_api.GetListAtivos()
            .then(response => setListUsuarios(response.data))
            .catch(e => showMessage("Erro", e?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    const loadColegiadoVotacao = (id = null) => {
        if (id != null || colegiadoVotacao?.id != null) {
            setLoading(true);
            colegiadoVotacao_api.getItem(id ?? colegiadoVotacao?.id)
                .then(response => setColegiadoVotacao(response.data))
                .catch(e => showMessage("Erro", e?.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        }
    }

    useEffect(() => {
        loadColegiadoVotacao(id);
        loadUsuarios();
    }, []);

    //Campos obrigatorios
    const campos = [
        objCampo({ name: "identificacao", required: true })
    ];

    //onChange para os multiSelects
    const onChangeMultiSelect = (e, select) => {
        const { name } = select;
        setColegiadoVotacao({
            ...colegiadoVotacao,
            [name]: e && e.length > 0 ? e.map(value => value.value) : []
        })
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        const _colegiadoVotacao = {
            ...colegiadoVotacao,
            [name]: value
        };
        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_colegiadoVotacao, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setColegiadoVotacao(_colegiadoVotacao);
    }

    const onSumitColegiadoVotacao = () => {
        const _errors = validarCampos(colegiadoVotacao, campos);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        const _colegiadoVotacao = { ...colegiadoVotacao };

        if (_colegiadoVotacao.id) {
            setLoading(true);
            colegiadoVotacao_api.put(_colegiadoVotacao)
                .then(response => showMessage("Sucesso", "Sucesso na operação.", "success", handleVoltar))
                .catch(e => showMessage("Erro", e?.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        } else {
            setLoading(true);
            colegiadoVotacao_api.post(_colegiadoVotacao)
                .then(response => showMessage("Sucesso", "Sucesso na operação.", "success", handleVoltar))
                .catch(e => showMessage("Erro", e?.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        }
    }

    return <>
        <Button onClick={() => {
            handleVoltar()
        }} className='px-4'>
            <FontAwesomeIcon icon={faAngleLeft} className='me-2' />
            Voltar
        </Button>
        <MainCard>
            <h5 style={{ color: "#666" }}>Cadastro Colegiado Votação</h5>
            <Row >
                <Col md={12} lg={10}>
                    <TextField
                        name={"identificacao"}
                        label={"* Identificação"}
                        type={"text"}
                        value={colegiadoVotacao.identificacao}
                        onChange={onChange}
                        maxLength={100}
                        invalid={errors.identificacao}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        name={"status"}
                        label={"* Status"}
                        type={"select"}
                        options={[
                            { value: "true", label: "Ativo" },
                            { value: "false", label: "Inativo" }
                        ]}
                        value={colegiadoVotacao.status}
                        onChange={onChange}
                        maxLength={8}
                        disabled={!editavel}
                    />
                </Col>
                <TextField
                    name={"colegiadoUsuarios"}
                    label={"Usuários"}
                    multiple
                    type={"select"}
                    value={
                        listUsuarios.filter(c => colegiadoVotacao.colegiadoUsuarios.some(x => x == c.id))
                            .map(v => { return { value: v.id.toString(), label: v.nome } })
                    }
                    options={
                        listUsuarios.filter(c => !colegiadoVotacao.colegiadoUsuarios.some(x => x == c.id))
                            .map(v => { return { value: v.id.toString(), label: v.nome } })
                    }
                    onChange={onChangeMultiSelect}
                    disabled={!editavel}
                />

                <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center ${editavel ? "" : "d-none"}`}>
                    <Button
                        className='px-4'
                        color={colegiadoVotacao.id ? 'warning text-white' : 'success'}
                        onClick={onSumitColegiadoVotacao}>{colegiadoVotacao.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}
                    </Button>
                </Col>
            </Row>
        </MainCard>
    </>;
}

export default CadastroColegiadoVotacao;